import * as noUiSlider from '../../../../../node_modules/nouislider';
import { PhotoshopController } from '../../../../photoshopController.js';
import { ParametersWidget } from './parameterWidget.js';

declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}
export class LuminosityContrastParameterWidget extends ParametersWidget {

    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = LuminosityContrastParameterWidget.html();
        super.initEvent();


        const lcAdvancedInput = document.getElementById("lc-advanced-input");
        if (lcAdvancedInput) {
            lcAdvancedInput.addEventListener("change", function (event) {
                this.lc_advanced_inputOnChange((event.currentTarget as HTMLInputElement).checked);
                this.updateIf();
                this.updateModel();
            }.bind(this));
        }

        this.updateModel();
        this.initializeLuminosityContrastRange();
    }

    static html() {
        return super.header() +
            '\
            <div id="luminosityContrast" style="display: none; padding: 10px;">\
            <h4 class="center-align"> Luminosité / Contraste</h4>\
            <div class="col s12 divider"></div>\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Luminosité</div>\
                <div class="col s2 no-padding">\
                    <input id="lc-luminosity-input" type="number">\
                </div>\
        </div>\
        <div class="col s12 no-padding">\
            <div id="lc-luminosity-range" class="col s12 row"></div>\
        </div>\
        <div class="col s12 divider"></div>\
        <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
            <div id="lc-advanced-label" class="col s10 no-padding">Contraste</div>\
            <div class="col s2 no-padding">\
                <input id="lc-contrast-input" type="number">\
            </div>\
        </div>\
        <div class="col s12 no-padding">\
            <div id="lc-contrast-range" class="col s12 row"></div>\
        </div>\
        <div id="lc-advanced" style="display: none;">\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Contraste</div>\
                <div class="col s2 no-padding">\
                    <input id="lc-radius-input" type="number" step="0.1">\
                </div>\
            </div>\
            <div class="col s12 no-padding">\
                <div id="lc-radius-range" class="col s12 row"></div>\
            </div>\
        </div>\
        <div class="col s12 no-padding">\
            <p>\
                <label>\
                    <input id="lc-advanced-input" type="checkbox">\
                    <span>Contraste avancé</span>\
                </label>\
            </p>\
        </div>\
        </div>'
            + super.footer();
    }

    lc_advanced_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.advanced = value;
        this.initializeLuminosityContrastRange();
    }

    lc_luminosity_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.luminosity = value;
        this.photoshopController.update();
    }

    lc_contrast_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.contrast = value;
        this.photoshopController.update();
    }

    lc_radius_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.radius = value;
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {
            if (this.photoshopController.PSEngine.activeOperation.advanced !== undefined) {
                const lcAdvancedInput = document.getElementById("lc-advanced-input") as HTMLInputElement | null;
                if (lcAdvancedInput) {
                    lcAdvancedInput.checked = this.photoshopController.PSEngine.activeOperation.advanced;
                }
                if (this.photoshopController.PSEngine.activeOperation.advanced) {
                    const lcAdvancedLabel = document.getElementById("lc-advanced-label");
                    if (lcAdvancedLabel) {
                        lcAdvancedLabel.textContent = "Gain";
                    }
                } else {
                    const lcAdvancedLabel = document.getElementById("lc-advanced-label");
                    if (lcAdvancedLabel) {
                        lcAdvancedLabel.textContent = "Contraste";
                    }
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.luminosity !== undefined) {
                const lcLuminosityInput = document.getElementById("lc-luminosity-input") as HTMLInputElement | null;
                if (lcLuminosityInput) {
                    lcLuminosityInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.luminosity;
                    lcLuminosityInput.min = this.photoshopController.PSEngine.activeOperation.minLuminosity;
                    lcLuminosityInput.max = this.photoshopController.PSEngine.activeOperation.maxLuminosity;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.contrast !== undefined) {
                const lcContrastInput = document.getElementById("lc-contrast-input") as HTMLInputElement | null;
                if (lcContrastInput) {
                    lcContrastInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.contrast;
                    lcContrastInput.min = this.photoshopController.PSEngine.activeOperation.minContrast;
                    lcContrastInput.max = this.photoshopController.PSEngine.activeOperation.maxContrast;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.radius !== undefined) {
                const lcRadiusInput = document.getElementById("lc-radius-input") as HTMLInputElement | null;
                if (lcRadiusInput) {
                    lcRadiusInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.radius;
                    lcRadiusInput.min = this.photoshopController.PSEngine.activeOperation.minRadius;
                    lcRadiusInput.max = this.photoshopController.PSEngine.activeOperation.maxRadius;
                }
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        super.updateIf();
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'luminosityContrast') {
            const luminosityContrastElem = document.getElementById("luminosityContrast");
            if (luminosityContrastElem) {
                luminosityContrastElem.style.display = "";
            }
        }
        else {
            const luminosityContrastElem = document.getElementById("luminosityContrast");
            if (luminosityContrastElem) {
                luminosityContrastElem.style.display = "none";
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.advanced) {
            const lcAdvancedElem = document.getElementById("lc-advanced");
            if (lcAdvancedElem) {
                lcAdvancedElem.style.display = "";
            }
        } else {
            const lcAdvancedElem = document.getElementById("lc-advanced");
            if (lcAdvancedElem) {
                lcAdvancedElem.style.display = "none";
            }
        }
    }

    initializeLuminosityContrastRange() {
        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
            return;
        }
            var luminosityRange = document.getElementById("lc-luminosity-range");
            if (luminosityRange) {
                if (luminosityRange.noUiSlider) {
                    luminosityRange.noUiSlider.destroy();
                }
                noUiSlider.create(luminosityRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.luminosity],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minLuminosity,
                        max: this.photoshopController.PSEngine.activeOperation.maxLuminosity
                    }
                });
                if (luminosityRange.noUiSlider) {
                    luminosityRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.luminosity = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const lcLuminosityInput = document.getElementById('lc-luminosity-input');
                if (lcLuminosityInput) {
                    lcLuminosityInput.addEventListener('change', function (event) {
                        this.lc_luminosity_inputOnChange((event.currentTarget as HTMLInputElement).valueAsNumber);
                        if (luminosityRange && luminosityRange.noUiSlider) {
                            luminosityRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).valueAsNumber]);
                        }
                    }.bind(this));
                }
            }

            var contrastRange = document.getElementById("lc-contrast-range");
            if (contrastRange) {
                if (contrastRange.noUiSlider) {
                    contrastRange.noUiSlider.destroy();
                }
                noUiSlider.create(contrastRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.contrast],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minContrast,
                        max: this.photoshopController.PSEngine.activeOperation.maxContrast
                    }
                });
                if (contrastRange.noUiSlider) {
                    contrastRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.contrast = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const lcContrastInput = document.getElementById('lc-contrast-input');
                if (lcContrastInput) {
                    lcContrastInput.addEventListener('change', function (event) {
                        this.lc_contrast_inputOnChange((event.currentTarget as HTMLInputElement).valueAsNumber);
                        if (contrastRange && contrastRange.noUiSlider) {
                            contrastRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).valueAsNumber]);
                        }
                    }.bind(this));
                }
            }

            var radiusRange = document.getElementById("lc-radius-range");
            if (radiusRange) {
                if (radiusRange.noUiSlider) {
                    radiusRange.noUiSlider.destroy();
                }
                noUiSlider.create(radiusRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.radius],
                    step: 0.1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minRadius,
                        max: this.photoshopController.PSEngine.activeOperation.maxRadius
                    }
                });
                if (radiusRange.noUiSlider) {
                    radiusRange.noUiSlider.on('update', function (values, handle) {
                        var radius = Number(values[0]);
                        this.photoshopController.PSEngine.activeOperation.radius = radius;
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const lcRadiusInput = document.getElementById('lc-radius-input');
                if (lcRadiusInput) {
                    lcRadiusInput.addEventListener('change', function (event) {
                        this.onChange(event.currentTarget.id, event.currentTarget.valueAsNumber);
                        if (radiusRange && radiusRange.noUiSlider) {
                            radiusRange.noUiSlider.set([event.currentTarget.valueAsNumber]);
                        }
                    }.bind(this));
                }
            }
        });
    }

    reglages_undoOnClick() {
        super.reglages_undoOnClick();
        this.updateModel();
        this.updateIf();
        this.initializeLuminosityContrastRange();
    }
}